export const FIELD_TEST_TYPE_OPTIONS = [
  { value: 'pre-flight', label: 'Pre-Flight Check' },
  { value: 'post-flight', label: 'Post-Flight Inspection' },
  { value: 'equipment', label: 'Equipment Test' },
  { value: 'calibration', label: 'Calibration Test' }
] as const;

export const CUSTOM_FIELD_TEST_TYPE_OPTIONS = [
  { value: 'nozzle-calibration', label: 'Nozzle Calibration' },
  { value: 'equipment-inspection', label: 'Equipment Inspection' },
  { value: 'spray-pattern', label: 'Spray Pattern Test' },
  { value: 'flow-rate', label: 'Flow Rate Test' },
  { value: 'tank-calibration', label: 'Tank Calibration' },
  { value: 'other', label: 'Other' }
] as const;
